var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00039 15.6664L8.74727 15.357C8.57852 15.132 4.27539 10.0977 4.27539 7.08829C4.27539 4.47266 6.41289 2.36328 9.00039 2.36328C11.5879 2.36328 13.7254 4.50079 13.7254 7.08829C13.7254 10.0977 9.42226 15.1602 9.25351 15.357L9.00039 15.6664ZM9.00039 3.01016C6.75039 3.01016 4.95039 4.83828 4.95039 7.06016C4.95039 9.42266 8.07227 13.4445 9.00039 14.5977C9.92852 13.4445 13.0504 9.45078 13.0504 7.06016C13.0504 4.83828 11.2504 3.01016 9.00039 3.01016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00019 8.88907C8.01582 8.88907 7.2002 8.07344 7.2002 7.08907C7.2002 6.10469 8.01582 5.28906 9.00019 5.28906C9.98457 5.28906 10.8002 6.10469 10.8002 7.08907C10.8002 8.07344 9.98457 8.88907 9.00019 8.88907ZM9.00019 5.96407C8.38144 5.96407 7.87519 6.47032 7.87519 7.08907C7.87519 7.70782 8.38144 8.21407 9.00019 8.21407C9.61894 8.21407 10.1252 7.70782 10.1252 7.08907C10.1252 6.47032 9.61894 5.96407 9.00019 5.96407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.354bed1fd72460793a35d1fff39435fe.svg";
export { ForwardRef as ReactComponent };